import { mapGetters, mapActions } from 'vuex'

export const folderStoreActions = {
  ...mapActions('folderStore', [
    'getFolders',
    'createFolder',
    'updateFolder',
    'deleteFolder',
    'deleteBusy',
    'deleteUnnocupied',
    'cleanedForm'
  ])
}

export const folderStoreData = {
  ...mapGetters('folderStore', [
    'folders',
    'folderItemKey',
    'folderItemText',
    'folderRoot',
    'isTableBusy',
    'loadingText',
    'noDataText',
    'folderDeleteLabels',
    'isDeleting',
    'messageFolderUnselected',
    'codeFolderServicePost200',
    'codeFolderServicePut200',
    'codeFolderServiceDelete200',
    'msgFolderServiceError',
    'msgFolderServiceDeleteError'
  ])
}
